// extracted by mini-css-extract-plugin
module.exports = {"livepreview_container":"styles_livepreview_container__1HjyS","title":"styles_title__3G7mm","preview":"styles_preview__J1_yU","livepreview_nav":"styles_livepreview_nav__2pqFm"};